/**
 * UNA PESTAÑA ABIERTA DESDE ANTES DEL ULTIMO DESPLIEGUE.
 *
 * Cada pantalla es un archivo aparte con un hash en el nombre
 * (Cartera-BHKyDFDX.js), y los assets viven dentro de la imagen de nginx: al
 * desplegar, los de la version anterior dejan de existir. Una pestaña que
 * cargo el panel antes sigue pidiendo esos nombres, recibe 404 y la pantalla
 * no abre ("Failed to fetch dynamically imported module"). Le paso a Diego
 * varias veces el 07-oct-2026, un dia de muchos despliegues.
 *
 * Vite avisa con el evento `vite:preloadError`. Lo que se hace es recargar:
 * el index.html va sin cache (ver docker-compose/nginx/default.conf), asi que
 * la recarga trae los nombres nuevos y el usuario sigue donde iba.
 *
 * El candado evita el bucle: si el archivo falla por otra cosa --sin red, el
 * servidor caido-- recargar no lo arregla, y sin candado la pagina se
 * recargaria para siempre. Se recarga una vez por minuto como mucho; si vuelve
 * a fallar dentro de ese minuto, el error sigue su curso y se ve.
 */

const CLAVE = 'cobranza:recarga-tras-despliegue'

export const VENTANA_MS = 60_000

type Almacen = Pick<Storage, 'getItem' | 'setItem'>

/** Si toca recargar ahora; si toca, deja anotado cuando. */
export function debeRecargar(almacen: Almacen, ahora: number): boolean {
  let anterior = 0

  try {
    anterior = Number(almacen.getItem(CLAVE) ?? 0)
  } catch {
    // Sin almacenamiento (modo privado estricto) no hay candado posible:
    // mejor no recargar que arriesgar un bucle.
    return false
  }

  if (ahora - anterior < VENTANA_MS) {
    return false
  }

  try {
    almacen.setItem(CLAVE, String(ahora))
  } catch {
    return false
  }

  return true
}

export function instalarRecargaTrasDespliegue(
  ventana: Window = window,
  recargar: () => void = () => {
    ventana.location.reload()
  },
): void {
  ventana.addEventListener('vite:preloadError', (evento) => {
    if (debeRecargar(ventana.sessionStorage, Date.now())) {
      // Sin preventDefault el error se lanzaria igual y la pantalla de error
      // alcanzaria a parpadear antes de la recarga.
      evento.preventDefault()
      recargar()
    }
  })
}
